/** Pure function: linear regression trend detection for manual readings. */
const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000;
export function detectTrend(readings, parameter) {
    const filtered = readings
        .filter((r) => r.parameter === parameter)
        .sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
    if (filtered.length < 3)
        return null;
    const firstTs = new Date(filtered[0].timestamp).getTime();
    const lastTs = new Date(filtered[filtered.length - 1].timestamp).getTime();
    const spanMs = lastTs - firstTs;
    if (spanMs < 7 * MS_PER_WEEK)
        return null;
    // Linear regression: y = mx + b where x = days since first reading
    const n = filtered.length;
    let sumX = 0;
    let sumY = 0;
    let sumXY = 0;
    let sumXX = 0;
    for (const r of filtered) {
        const x = (new Date(r.timestamp).getTime() - firstTs) / MS_PER_WEEK;
        const y = r.value;
        sumX += x;
        sumY += y;
        sumXY += x * y;
        sumXX += x * x;
    }
    const denominator = n * sumXX - sumX * sumX;
    if (denominator === 0)
        return null;
    const slope = (n * sumXY - sumX * sumY) / denominator;
    const weeksOfData = Math.max(0, spanMs / MS_PER_WEEK);
    // Confidence based on number of data points
    let confidence = 'low';
    if (n >= 8)
        confidence = 'high';
    else if (n >= 5)
        confidence = 'medium';
    // Direction
    const absSlope = Math.abs(slope);
    let direction = 'stable';
    if (absSlope > 0.05) {
        direction = slope > 0 ? 'rising' : 'falling';
    }
    return {
        parameter,
        slopePerWeek: slope,
        weeksOfData: Math.round(weeksOfData * 10) / 10,
        confidence,
        direction,
    };
}
//# sourceMappingURL=trends.js.map